import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from './AuthContext';
import { useCapabilities } from './CapabilitiesContext';

/**
 * Substitui o RequireRole nas rotas. Rota com `capability` passa pela matriz;
 * rota sem capability (redirects, /unauthorized) cai no comportamento antigo
 * por `roles`.
 */
function RequireCapability({ capability, roles, children }) {
  const { can } = useCapabilities();
  const { hasAnyRole } = useContext(AuthContext);

  const authorized = capability
    ? can(capability)
    : Array.isArray(roles) && (roles.length === 0 || hasAnyRole(roles));

  useEffect(() => {
    if (!authorized) toast.error('You are not authorized to view this page');
  }, [authorized]);

  if (!authorized) return <Navigate to="/unauthorized" replace />;

  return <>{children}</>;
}

export default RequireCapability;
